import {
    LIST_LICENCES,
    LIST_LICENCES_SUCCESS,
    LIST_LICENCES_ERROR,
    ADD_LICENCES,
    SAVE_LICENCES,
    SAVE_LICENCES_SUCCESS,
    SAVE_LICENCES_ERROR,
    EDIT_LICENCES,
    UPDATE_LICENCES,
    UPDATE_LICENCES_SUCCESS,
    UPDATE_LICENCES_ERROR,
    DELETE_LICENCES,
    DELETE_LICENCES_SUCCESS,
    DELETE_LICENCES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    licences: null,
    actualPage: null,
    isLast: null,
    isFirst: null,
    total: null,
    totalPages: null,
    error: null,
    loading: false,
    licenceSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_LICENCES:
            return {
                ...state,
                loading: true
            }
        case LIST_LICENCES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_LICENCES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                licences: action.payload.content,
                actualPage: action.payload.number,
                isLast: action.payload.last,
                isFirst: action.payload.first,
                total: action.payload.totalElements,
                totalPages: action.payload.totalPages
            }
        case SAVE_LICENCES:
        case DELETE_LICENCES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_LICENCES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_LICENCES_ERROR:
        case UPDATE_LICENCES_ERROR:
        case DELETE_LICENCES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_LICENCES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                licences: [...state.licences, action.payload]
            }
        case ADD_LICENCES:
            return {
                ...state,
                licenceSelected: null,
                isEdit: false
            }
        case EDIT_LICENCES:
            return {
                ...state,
                licenceSelected: action.payload,
                isEdit: true
            }
        case UPDATE_LICENCES_SUCCESS:
        case DELETE_LICENCES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                licences: state.licences.map(licence => 
                    licence.id === action.payload.id ? licence = action.payload : licence
                ),
                licenceSelected: null
            }
        // case DELETE_LICENCES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         licences: state.licences.filter( licence => licence.id !== action.payload)
        //     }
        default:
            return state;
    }
}